import axios from '@/http';
export function getList() {
  return axios.get('app/shoppingcart', {
    params: {
      page_num: 0,
      page_size: 0
    }
  }).then(function (res) {
    return res.data.extraInfo.list;
  });
}
export function addItem(tickets) {
  return axios.post('/app/shoppingcart', {
    tickets: tickets
  }).then(function (res) {
    return res.data.extraInfo;
  });
}
export function deleteItem(id) {
  return axios.delete("/app/shoppingcart/".concat(id));
}
export function updateItem(item) {
  return axios.post("/app/shoppingcart/".concat(item.id), item).then(function (res) {
    return res.data.extraInfo;
  });
}